import type { CreatePartyRequest } from '@uznali/api-client';
import { apiClient } from './client';
import { partyEntrySchema, partySnapshotSchema } from './party-contract';

export const partyApi = {
  create: async (body: CreatePartyRequest) => partyEntrySchema.parse(await apiClient.party.create(body)),
  join: async (code: string, displayName: string) =>
    partyEntrySchema.parse(await apiClient.party.join(code, { displayName })),
  snapshot: async (code: string) => partySnapshotSchema.parse(await apiClient.party.getSnapshot(code)),
};
